import script from "./InputText.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputText.vue?vue&type=script&setup=true&lang=ts"

import "./InputText.vue?vue&type=style&index=0&id=5ae8aeba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ae8aeba"]])

export default __exports__